import '../paedml-modal.tag'
import '../paedml-form-input.tag'

<paedml-modal-createoredit-fwtemplate>
  <paedml-modal prefix={opts.prefix} heading={opts.heading} opname={opts.opname} edit={opts.edit} selectedrowsfunc={opts.selectedrowsfunc} idcol={opts.idcol} idtextcol={opts.idtextcol}
    submitfunc={submitHandler}>
  
    <yield to="fields">

      <div class="paedml-input-group">
        <div class="row">
          <div class="col-sm-12">
            <paedml-form-input name="name" col="1" label="Name"
              required data-msg="Bitte geben Sie einen Namen ein"
              maxlength="31" data-rule-maxlength="30" data-msg-maxlength="Der Name darf nicht länger als 30 Zeichen sein"
            />
          </div>
          <div class="col-sm-12">
            <paedml-form-input name="description" col="2" label="Beschreibung"
            />
          </div>
        </div>
      </div>

    <div class="paedml-input-group">
      <div class="pb-1">
          Whitelist:
      </div>
      <div class="row">
        <div class="col-sm-12">
          <paedml-form-input name="schoolClass" label="Optional: Standard-Whitelist von Klasse laden"
              type="select" values={parent.getClassesMapped()}
              handlechange={parent.handleSchoolClassChange}
            />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label>Whitelist</label>
            <textarea class="form-control" maxlength=4097 data-rule-maxlength=4096 data-msg-maxlength="Es sind bis zu 4096 Zeichen erlaubt" name="whitelist" cols="28" rows="10"></textarea>
            <a class="text-info mt-2" data-toggle="collapse" href="#{parent.inputid}" aria-expanded="false" aria-controls={parent.inputid}>
                <paedml-icon icon="fas-info-circle" simple="info" />
                In welcher Form, kann eine URL in die Whitelist eingetragen werden? 
            </a> 
            <div class="collapse" id={parent.inputid}>
              <div class="paedml-input-group text-small">
                Die eingegebenen URLs müssen von der Firewall verstanden werden. Deshalb gibt es ein paar wenige, aber wichtige Regeln für die Eingabe von URLs in eine Whitelist. 
                <br/><br/>
                Die Präfixe <strong>https://</strong> und <strong>http://</strong> dürfen nicht mitgeschrieben werden. 
                <ul>
                  <li>Nicht: <strong>https://www.planet -schule.de</strong></li>
                  <li>Sondern: <strong>www.planet -schule.de</strong></li>
                  <li>Noch einfacher mit Wildcards: <strong>*.planet-schule.*</strong></li>
                </ul>  
                Enthält die URL ein oder mehrere Slashes, so muss die Eingabe vor dem ersten Slash enden.
                <ul>
                  <li>Nicht: <strong>https://www.planet-schule.de/fach/geschichte-110.html</strong></li>
                  <li>Sondern: <strong>www.planet-schule.de</strong></li>
                  <li>Noch einfacher mit Wildcards: <strong>*.planet-schule.*</strong></li>
                </ul>  
                Hier einige Beispiele, die zeigen, welche Möglichkeiten Sie haben, um mit Platzhaltern im Domain-Namen zu arbeiten: 
                 <ul>
                  <li><strong>www.google.de</strong> - Nur diese Kombination aus Sub- und Top-Level-Domain ist zulässig. Ausschließlich diese Domain ist freigegeben, andere werden gesperrt. Subdomains wie maps.google.de werden gesperrt.</li>
                  <li><strong>*.google.de</strong> - Alle Subdomains sind zulässig wie maps.google.de, translate.google.de usw.</li>
                  <li><strong>*.google.*</strong> - Alle Subdomains und Top-Level-Domains sind zulässig, wie z.B. transla-te.google.com, maps.google.at usw.</li>
                </ul> 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    </yield>
  </paedml-modal>
    
  <script>
    import store from '../../store'
    import { genDocId } from '../../util/crypto-util'
    import { client, handleSubmitCreateOrEdit } from '../../util/api-util'
    import * as mapper from '../../mapper'
    import * as R from 'ramda'
    import Session from '../../store/session'
    import Masterdata from '../../config/masterdata'
    import API from '../../api'

    this.variant = opts.variant
    this.opname = this.opts.opname
    this.edit = this.opts.edit ? true : false
    this.data = {}
    this.api = this.opts.api
    this.session = Session

     this.inputid = 'whitelistInfo' + genDocId();

    this.getClassesMapped = () => {
      const klassen = [[' ', 'Klasse wählen (Standard-Whitelist wird geladen)']]

      R.forEachObjIndexed((klasse, schulartId) => {
        if (schulartId !== 'undefined' && schulartId !== 'all') {
          const schulart = this.session.map.schularten[schulartId]
          klasse.forEach(v => {
            const klasse = `${schulart}_${v[1]}`
            klassen.push([v[0], klasse])
          })
        }
      })(Session.lut.klassenBySchulart)
      return klassen
    }

    this.handleSchoolClassChange = (val) => {
      if (val === ' ' || val == null) {
        return
      }

      API.fwklassen.whitelist(val).then(rsp => {
        const [data, status] = rsp
        
        if (status.success) {
            const whitelist = R.join('\n', data.whitelist || [])
            this.root.querySelector('textarea[name="whitelist"]').value = whitelist
        }
      })
    }

    this.on('rowMappingRequested', cols => {
      console.log('rowMappingRequested')
      this.data.id = cols[0]
      this.data.name = cols[1]
      this.data.description = cols[2]
      this.data.whitelist = R.join('\n', cols[4])
    })

    const normalizeList = str => str ? str.split('\n').map(R.trim).filter(e => !R.isEmpty(e)) : []

    this.submitHandler = formData => {
      console.log("submitHandler")

      formData.whitelist = normalizeList(formData.whitelist)

      return handleSubmitCreateOrEdit(this, data => `Whitelist-Vorlage "${data.name}"`, data => `Whitelist-Vorlage "${data.name}"`, false, true)(formData)
    }
  </script>
</paedml-modal-createoredit-fwtemplate>
